let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("a5LAU"), load("8FZ8H"), load("h9HVN"), load("gHcAo")]).then(() => parcelRequire('9lWJ9'));